
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#444"}},[_c('g',{attrs:{"stroke-width":"1.228"}},[_c('path',{attrs:{"d":"M35.533 29.246H3.467A2.462 2.462 0 011 26.789V3.456A2.462 2.462 0 013.467 1h32.066C36.896 1 38 2.1 38 3.456V26.79a2.462 2.462 0 01-2.467 2.457h0zM1 21.877h37M23.2 32.316v3.07M15.8 35.386v-3.07M10.867 35.386h17.266"}})]),_c('path',{attrs:{"d":"M24 6l-7.143 5.926v3.704l1.947-2.26"}}),_c('path',{attrs:{"d":"M14 9.704L24 6l-1.786 10z"}})])])
          )
        }
      }
    